<template>
  <div class="car-class">
    <div class="card-header bg-default">
        {{ carClass.name }}
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <p v-for="carType in carClass.CarTypes">
          <router-link :to="{ path: '/fleet/vehicles/types/' + carType.uuid }">
            {{ carType.name }}
          </router-link>
        </p>
      </div>
      <div class="col-sm-12">
        <h4>Rates</h4>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12" v-for="rate in carClass.Rates">
        <responsive-table
          :hideTitle="true"
          :table="{ columns: [{ title: rate.AccountType.name, span: 12}] }"
          :disableExpand="true">
          <template slot="rows">
            <div class="row-eq-height row billing-item">
              <div class="rt-cell col-xs-4">
                <div class="text-center">
                  <strong>Hourly:</strong>
                </div>
              </div>
              <div class="rt-cell last-rt-cell col-xs-8">
                <div class="text-center">
                  {{ rate.hourlyRate | to_dollar_amount }}
                </div>
              </div>
            </div>
            <div class="row-eq-height row billing-item">
              <div class="rt-cell col-xs-4">
                <div class="text-center">
                  <strong>Daily:</strong>
                </div>
              </div>
              <div class="rt-cell last-rt-cell col-xs-8">
                <div class="text-center">
                  {{ rate.dailyRate | to_dollar_amount }}
                </div>
              </div>
            </div>
            <div class="row-eq-height row billing-item">
              <div class="rt-cell col-xs-4">
                <div class="text-center">
                  <strong>Weekend:</strong>
                </div>
              </div>
              <div class="rt-cell last-rt-cell col-xs-8">
                <div class="text-center">
                  {{ rate.weekendRate | to_dollar_amount }}
                </div>
              </div>
            </div>
            <div class="row-eq-height row billing-item">
              <div class="rt-cell col-xs-4">
                <div class="text-center">
                  <strong>Overnight:</strong>
                </div>
              </div>
              <div class="rt-cell last-rt-cell col-xs-8">
                <div class="text-center">
                  {{ rate.overnightRate | to_dollar_amount }}
                </div>
              </div>
            </div>
            <div class="row-eq-height row billing-item">
              <div class="rt-cell last-rt-cell col-xs-12">
                <router-link class="btn btn-info btn-sm" :to="'/membership/rates/vehicles/edit/' + rate.uuid">
                  <span class="fa fa-edit fa-fw"></span> Edit
                </router-link>
              </div>
            </div>
          </template>
        </responsive-table>
        <br/>
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-primary"
            :to="{ path: `/fleet/vehicles/classes/edit/${carClass.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
import ResponsiveTable from '@/components/ResponsiveTable'
export default {
  name: 'CarClass',
  props: {
    object: {
      type: Object
    }
  },
  components: {
    ResponsiveTable
  },
  computed: {
    carClass () {
      return {
        Rates: [],
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/CarClass.vue